import {
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import {
  Collapse,
  List,
  ListItem,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ChecklistTask } from "../../common/ChecklistTask";
import {
  useGetChecklistQuery,
} from "../../redux/api/checklist";

interface JobRequirementsDisplayProps {
  root: ChecklistTask;
  userId: number | undefined;
}

const JobRequirementsDisplay = (props: JobRequirementsDisplayProps) => {
  const checklistId = props.root.id;
  const [expanded, setExpanded] = useState<{
    [fieldName: number]: boolean;
  }>({});
  const [subTasks, setSubTasks] = useState<ChecklistTask[]>([]);

  const {
    data: checklist,
    isLoading,
    isFetching,
  } = useGetChecklistQuery(checklistId as number);

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setSubTasks(
        !!checklist?.subTasks && checklist?.subTasks.length > 0
          ? [...checklist?.subTasks]
          : []
      );
    }
  }, [checklist?.subTasks, isFetching, isLoading]);

  return (
    <>
      {!isLoading && !!subTasks && subTasks.length > 0 && (
        <Paper className="checklist">
          <div>
            <h3>Requirements</h3>
          </div>
          <List className="progress-list">
            {subTasks
              .sort((a, b) => {
                if (a.position && b.position) {
                  return a.position > b.position ? 1 : -1;
                } else if (b.position) {
                  return -1;
                } else {
                  return 1;
                }
              })
              .filter((task) => {
                return !!task.description && ["Merchant Mariner Credentials", "Shipping Docs", "COVID Vaccine Verified", "COVID Test Submitted"].includes(task.description)
              })
              .map((task) => {
                return (
                  <ListItem key={task.id} className="progress-item-wrap">
                    <div className="progress-item no-check">
                      <p className="progress-description">{task.description}</p>
                      {!!task.subTasks && task.subTasks?.length > 0 && (
                        <div className="progress-right">
                          <p
                            className={
                              (task.subTasksCompletedCount || 0) + (task.subTasksNotApplicableCount || 0) === task.subTasksCount
                                ? "completed"
                                : ""
                            }
                          >
                            {(task.subTasksCompletedCount || 0) + (task.subTasksNotApplicableCount || 0)}/{task.subTasksCount}
                          </p>
                          {!!task.id && expanded[task.id] ? (
                            <ExpandLess
                              onClick={() => {
                                let temp = expanded;
                                if (!!task.id) {
                                  temp[task.id] = false;
                                  setExpanded(temp);
                                  //Doesn't make any real changes is just used to refresh checklist and display changes
                                  const check = JSON.parse(
                                    JSON.stringify(subTasks)
                                  );
                                  setSubTasks(check);
                                }
                              }}
                            />
                          ) : (
                            <ExpandMore
                              onClick={() => {
                                let temp = expanded;
                                if (!!task.id) {
                                  temp[task.id] = true;
                                  setExpanded(temp);
                                  //Doesn't make any real changes is just used to refresh checklist and display changes
                                  const check = JSON.parse(
                                    JSON.stringify(subTasks)
                                  );
                                  setSubTasks(check);
                                }
                              }}
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {task.subTasks && task.subTasks.length > 0 && (
                      <Collapse
                        in={!!task.id && !!expanded && !!expanded[task.id]}
                      >
                        <List component="div" disablePadding>
                          {task.subTasks.map((subTask) => (
                            <ListItem
                              component="div"
                              key={subTask.id}
                              className="sub-task-no-check"
                            >
                              <span>{subTask.description}</span>
                            </ListItem>
                          ))}
                        </List>
                      </Collapse>
                    )}
                  </ListItem>
                );
              })}
          </List>
        </Paper>
      )}
    </>
  );
};

export default JobRequirementsDisplay;
